// extracted by mini-css-extract-plugin
export default {"container":"aK7XxMLF0Hkg9GekZ8Et","dot":"_P9gscrl0_CcXnh0fSEV","profilelist":"F_yfVpB5uy67jJI01U7t","digitfocus":"BCP7wfo36dwkAFNdIclw"};